"use client";

import ExecEdTaxiForm from "@/components/TaxiForm/variants/ExecEd";
import { FeatureFlagComponentResolverClient } from "@/lib/feature-flags/FeatureFlagResolverClient";
import { StreamlineCheckoutTestResult } from "@/monarch/rules/streamlineCheckout/types";
import MonarchResolver from "@/monarch/MonarchResolver";
import { MonarchDataConsumer } from "@/monarch/MonarchDataConsumer";
import styles from "./styles.module.css";
import { GetMoreInformationTaxiFormProps } from "./types";
import Header from "./Header";
import DiscountCTA from "@/components/ExecEd/components/DiscountCTA";

export default function GetMoreInformationTaxiForm({
  formID,
  submitUrl,
  formSalt,
  brand,
  productvariant,
  category,
  name,
  segmenteventdata,
  conversionType,
  productUuid,
  externalIdentifier,
  taxiFormData,
  courseSlug,
}: GetMoreInformationTaxiFormProps) {
  return (
    <FeatureFlagComponentResolverClient
      flagKey="NEXT_PUBLIC_FEATURE_STREAMLINE_CHECKOUT"
      variants={{
        legacy: (
          <>
            <div className="bg-putty-200 px-4 pb-4 h-full rounded-xl md:rounded-l-none">
              <div className="flex flex-col mb-4">
                <Header />
                <div className="text-sm">
                  Want to know more? Enter your information to learn more about
                  this course from GetSmarter. GetSmarter and edX are owned by
                  2U.
                </div>
              </div>
              <div className="">
                <ExecEdTaxiForm
                  variant="exec-ed"
                  formgrouping={""}
                  formid={formID}
                  postsubmiturl={submitUrl}
                  subtitle={""}
                  title={""}
                  salt={formSalt}
                  brand={brand}
                  productvariant={productvariant}
                  category={category}
                  name={name}
                  segmenteventdata={segmenteventdata}
                  showLoading
                  customName={conversionType}
                  productUuid={productUuid}
                  taxiFormData={taxiFormData}
                />
              </div>
            </div>
          </>
        ),
        test: (
          <MonarchResolver<StreamlineCheckoutTestResult>
            experimentKey="useStreamlineCheckout"
            variants={{
              control: (
                <>
                  <div className="bg-putty-200 px-4 pb-4 h-full rounded-xl md:rounded-l-none">
                    <div className="flex flex-col mb-4">
                      <Header />
                      <div className="text-sm">
                        Want to know more? Enter your information to learn more
                        about this course from GetSmarter. GetSmarter and edX
                        are owned by 2U.
                      </div>
                    </div>
                    <div className="">
                      <ExecEdTaxiForm
                        variant="exec-ed"
                        formgrouping={""}
                        formid={formID}
                        postsubmiturl={submitUrl}
                        subtitle={""}
                        title={""}
                        salt={formSalt}
                        brand={brand}
                        productvariant={productvariant}
                        category={category}
                        name={name}
                        segmenteventdata={segmenteventdata}
                        showLoading
                        customName={conversionType}
                        productUuid={productUuid}
                        taxiFormData={taxiFormData}
                      />
                    </div>
                  </div>
                </>
              ),
              test: (
                <MonarchDataConsumer<StreamlineCheckoutTestResult>
                  experimentKey="useStreamlineCheckout"
                  render={({ data }) => {
                    return (
                      <>
                        <div className="md:mt-4 mb-4 m-0 md:m-2 bg-white">
                          {data && courseSlug && data?.position == "top" && (
                            <DiscountCTA
                              courseSlug={courseSlug}
                              buttonConfiguration={data}
                              externalIdentifier={externalIdentifier}
                            />
                          )}
                        </div>
                        <div className="m-0 md:m-2 bg-putty-200 rounded-[4px] p-4 bg-putty-100 border border-putty-400">
                          <div className="flex flex-col mb-4">
                            <Header />
                            <div className="text-sm">
                              Want to know more? Enter your information to learn
                              more about this course from GetSmarter. GetSmarter
                              and edX are owned by 2U.
                            </div>
                          </div>
                          <div className="">
                            <ExecEdTaxiForm
                              variant="exec-ed"
                              formgrouping={""}
                              formid={formID}
                              postsubmiturl={submitUrl}
                              subtitle={""}
                              title={""}
                              salt={formSalt}
                              brand={brand}
                              productvariant={productvariant}
                              category={category}
                              name={name}
                              segmenteventdata={segmenteventdata}
                              showLoading
                              customName={conversionType}
                              productUuid={productUuid}
                              taxiFormData={taxiFormData}
                            />
                          </div>
                        </div>
                        <div className="mt-4 m-0 md:m-2 bg-white">
                          {data && courseSlug && data?.position == "bottom" && (
                            <DiscountCTA
                              courseSlug={courseSlug}
                              buttonConfiguration={data}
                              externalIdentifier={externalIdentifier}
                            />
                          )}
                        </div>
                      </>
                    );
                  }}
                />
              ),
            }}
            fallbackVariant="control"
          />
        ),
      }}
      fallback="legacy"
    />
  );
}
